<template>
  <div>
    <pdf-reader
      v-if="item && item.lessonplan.classbook"
      v-model="pdfLoad"
      :src="item.lessonplan.classbook.url"
    ></pdf-reader>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  name: "products",
  props: ["id"],
  async created() {
    //надо получить группу!
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  mounted(){

  },
  watch:{
    pdfLoad(){
      setTimeout(() => {
        try {
          if(!this.item && !this.item.lessonplan.classbook)
            return

          document.getElementById(`pdf-${this.item.lessonplan.classbook_page}`).scrollIntoView({
            behavior: "smooth",
            block: "start", 
            inline: "nearest"
          })
        } catch (error) {
          console.log(error) 
        }
      }, 200);
    }
  },
  methods: {
    //getClass: getClass,
    cardContent: cardContent,
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      loadingStatus: null,
      pdfLoad: false,
      val: [],
      item: null, 
      modalCreate: "client_group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "business/timetables",
      itemLink: "",
      setLink: "",
    };
  },
};
</script>
<style>
</style>
